import { mapReportComponentType } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SearchablePeriscopeFieldGroupList } from '../../../general/fields';
function mapGroupForReports(group) {
    return {
        fields: group.fields,
        name: mapReportComponentType(group.componentType)
    };
}
export const ReportByComponentTab = ({ index, sonarObjectId }) => {
    const targetUri = `v2/salesforce/SfReports/${sonarObjectId}/RefsByComponent`;
    return (React.createElement(SearchablePeriscopeFieldGroupList, { mapGroup: mapGroupForReports, parentIndex: index, showParents: true, uri: targetUri }));
};
